var assets = [];
export function registerAsset(asset) {
  return assets.push(asset);
}
export function getAssetByID(assetId) {
  return assets[assetId - 1];
}